import { render } from "./other_actions.vue?vue&type=template&id=b57d289e"
import script from "./other_actions.vue?vue&type=script&lang=js"
export * from "./other_actions.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__